module.exports = __webpack_public_path__ + "img/kutatasi partner_gomb_aktiv.0472f693.png";